<template>
    <div v-show="isShow"
        class="fixed inset-0 left-none z-[80] box-default bg-[#06202E]/40 flex justify-center items-center">
        <div @click.stop="() => { }" class="relative rounded-lg overflow-auto shadow max-w-[90%] bg-white max-h-[90%] lg:max-w-[65%]" :class="size === 'sm' ? 'w-96': size === 'default'? 'gridClass' : size === 'custom' ? '' : ''">
            <slot />
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    isShow: {
        type: Boolean,
        required: false,
        default: false
    },
    button: {
        type: Object || null,
        required: false,
        default: null
    },
    type: {
        type: String || null,
        required: false,
        default: null,
    },
    hasClose: {
        type: Boolean,
        required: false,
        default: true
    },
    size: {
        type: String,
        required: false,
        default: 'default'
    }
})

const emit = defineEmits('close')

const close = () => {
    emit('close')
}

// watch(() => props.isShow, (newVal) => {
//     if (newVal) {
//         document.body.classList.add('overflow-hidden');
//     } else {
//         .body.classList.remove('overflow-hidden');
//     }
// });
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
</style>